import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import { FaMinimize, FaMaximize } from 'react-icons/fa6'
import defaultTexts from '../../../texts/texts'
import PaymentMethodsEdit from './PaymentMethodsEdit'

const PaymentMethodsWrapper = (props) => {
  const { setFetchAccountConfigs, accountConfigs, supportedPaymentMethods } = props
  const theme = useTheme()

  const [expanded, setExpanded] = useState(true)

  const [paymentMethods, setPaymentMethods] = useState([])
  const [availablePaymentMethods, setAvailablePaymentMethods] = useState([])

  const wrapperStyle = {
    background: 'white',
    borderRadius: '50px 20px 20px 20px',
    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.25)',
    marginBottom: '40px',
  }

  const headStyle = {
    width: '100%',
    height: '60px',
  }

  const bodyStyle = {
    padding: '20px',
  }

  const labelStyle = {
    height: '60px',
    background: theme.palette.violetsAreBlue,
    color: 'white',
    fontSize: '20px',
    fontWeight: '500',
    borderRadius: '50px 0px',
    padding: '0px 40px',    
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  useEffect(() => {
    if (accountConfigs && accountConfigs.currency && accountConfigs.currency.name) {
      let payment_methods = []

      supportedPaymentMethods.forEach(item => {
        const currency_object = item.currencies.find(item2 => item2.name === accountConfigs.currency.name)
        if (currency_object) {
          payment_methods.push(item)
        }
      })

      setAvailablePaymentMethods(payment_methods)
    } else {
      setAvailablePaymentMethods([])
    }
  }, [supportedPaymentMethods, accountConfigs])

  useEffect(() => {
    if (accountConfigs && accountConfigs.payment_methods) {
      setPaymentMethods(accountConfigs.payment_methods)
    } else {
      setPaymentMethods([])
    }
  }, [accountConfigs])
  
  return (
    <Box sx={wrapperStyle}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={headStyle}
      >
        <Box sx={labelStyle}>
          <Box>{defaultTexts.paymentMethods}</Box>
        </Box>
        <Box sx={{ paddingRight: '10px ' }}>
          {
            expanded ?
            <IconButton onClick={() => setExpanded(false)}>
              <FaMinimize color={theme.palette.greenSheen} />
            </IconButton> :
            <IconButton onClick={() => setExpanded(true)}>
              <FaMaximize color={theme.palette.greenSheen} />
            </IconButton>
          }
        </Box>
      </Stack>

      {
        expanded &&
        <Box sx={bodyStyle}>
          <PaymentMethodsEdit
            availablePaymentMethods={availablePaymentMethods}
            paymentMethods={paymentMethods}
            setFetchAccountConfigs={setFetchAccountConfigs}
          />
        </Box>
      }
    </Box>
  )
}

export default PaymentMethodsWrapper